import { Disclosure } from "@headlessui/react";
import React, { useEffect, useState } from "react";
import {
  IoIosArrowDown,
  IoIosArrowForward,
  IoIosArrowUp,
} from "react-icons/io";
import { Link, Outlet } from "react-router-dom";
import {
  ChangeTitle,
  decrypt,
  encrypt,
  formatPrice,
  getEncodedCookie,
  selectFormStyle2,
  selectStyle,
  toAbsoluteUrl,
  toasterrormsg,
  toastsuccessmsg,
} from "../../helpers/Reusable";
import { apiHeader, getData, postData } from "../../helpers/ApiHelper";
import {
  deleteCookie,
  getCookie,
  setCookie,
} from "../../helpers/CookieComponent";
import Select from "react-select";
import { CiCircleMinus, CiCirclePlus } from "react-icons/ci";
import { ToastContainer } from "react-toastify";

const Books = () => {
  ChangeTitle("Books");
  const [bookList, setBookList] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("INR");
  const [currencySymbol, setCurrencySymbol] = useState("₹");
  const [currencyList, setCurrencyList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [subjectList, setSubjectList] = useState([]);
  const [formatList, setFormatList] = useState([]);
  const [yearList, setYearList] = useState([]);
  const [languageList, setLanguageList] = useState([]);
  const [countryService, setCountryService] = useState("");
  const [bookCartList, setBookCartList] = useState([]);
  const [openIndex, setOpenIndex] = useState(null); // State to track which accordion is open
  // Initialize quantities in state, with each book ID starting at 1
  const [quantities, setQuantities] = useState({});
  const [bookCountry, setBookCountry] = useState("");
  const [bookSubject, setBookSubject] = useState("");
  const [bookFormat, setBookFormat] = useState("");
  const [bookAvalability, setBookAvalability] = useState("");
  const [bookPublicationYear, setBookPublicationYear] = useState("");
  const [bookLanguage, setBookLanguage] = useState("");
  const [year, setYear] = useState("");
  const [booksFilterData, setBooksFilterData] = useState({});
  console.log("languageList", languageList);
  const auth = decrypt(getCookie("token")) || "";

  // const currentYear = new Date().getFullYear();
  // const yearList = Array.from({ length: currentYear - 1950 + 1 }, (_, i) => ({
  //   value: (currentYear - i).toString(),
  //   label: (currentYear - i).toString(),
  // }));

  // Function to get the current quantity for a book, defaulting to 1 if not set
  const getQuantity = (bookId) => quantities[bookId] || 1;

  // Function to handle incrementing quantity
  const incrementQuantity = (bookId) => {
    setQuantities((prev) => ({
      ...prev,
      [bookId]: getQuantity(bookId) + 1,
    }));
  };

  // Function to handle decrementing quantity
  const decrementQuantity = (bookId) => {
    setQuantities((prev) => ({
      ...prev,
      [bookId]: Math.max(1, getQuantity(bookId) - 1), // Ensure minimum quantity is 1
    }));
  };

  // Accordion open verify function
  const isOpen = (index) => openIndex === index;

  // Accordion toggle function
  const toggleAccordion = (index) => {
    setOpenIndex((prevIndex) => (prevIndex === index ? -1 : index)); // Toggle or close the accordion
  };

  // Book List API Call
  const viewBookList = async (
    taxserviceId,
    currency,
    bookCountry,
    bookSubject,
    bookFormat,
    bookPublicationYear,
    bookLanguage
  ) => {
    const param = {
      offset: 0,
      limit: 0,
      countryId: bookCountry,
      currency: currency,
      // country: bookCountry,
      subject: bookSubject,
      format: bookFormat,
      dateOfPublication: bookPublicationYear,
      languageId: bookLanguage,
    };

    var response = await postData(
      "book/titleandprice/list",
      param,
      apiHeader(false)
    );
    console.log(response);

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const bookData = data.map((data) => {
        return {
          id: data._id,
          title: data.title,
          price: data.price,
          image: data.bookImage,
          currency: data.currency,
        };
      });
      setBookList(bookData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };
  // Currency API Call
  const viewCurrencyList = async () => {
    const param = {};
    // var response = await postData("country/list", param, apiHeader(false));
    var response = await postData("currency/list", param, apiHeader(false));

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const currencyData = data.map((data) => {
        return {
          id: data._id,
          value: data.countryDetail.currency,
          label: `${data.countryDetail.currencyName} (${data.countryDetail.currencySymbol}) - ${data.countryDetail.currency}`,
          currencySymbol: data.countryDetail.currencySymbol,
          currency: data.countryDetail.currency,
        };
      });
      setCurrencyList(currencyData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Country API Call
  const viewCountryList = async () => {
    const param = {};

    var response = await getData("book/country/list", param, apiHeader(false));

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data;
      const listData = data.map((data) => {
        return {
          id: data._id,
          value: data.countryId,
          label: data.countryName,
        };
      });
      setCountryList(listData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Subject API Call
  const viewSubjectList = async () => {
    const param = {};

    var response = await getData("book/subject/list", param, apiHeader(false));

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data;
      const listData = data.map((data) => {
        return {
          value: data,
          label: data,
        };
      });
      setSubjectList(listData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Format API Call
  const viewFormatList = async () => {
    const param = {};

    var response = await getData("book/format/list", param, apiHeader(false));

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data;
      const listData = data.map((data) => {
        return {
          value: data,
          label: data,
        };
      });
      setFormatList(listData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Year API Call
  const viewYearList = async () => {
    const param = {};

    var response = await getData(
      "book/yearofpublication/list",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data;
      const listData = data.map((data) => {
        return {
          value: data.year,
          label: data.year,
        };
      });
      setYearList(listData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Language API Call
  const viewLanguageList = async () => {
    const param = {};

    var response = await getData("book/language/list", param, apiHeader(false));

    console.log("viewLanguageList+++++++++++", response);

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data;
      const listData = data.map((data) => {
        return {
          value: data._id,
          label: data.languageName,
        };
      });
      setLanguageList(listData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Add Cart API Call
  const addBookInCart = async (id, qty, currency) => {
    const param = {
      bookId: id,
      quantity: qty,
      currency: currency,
    };

    var response = await postData("private/cart/add", param, apiHeader(false));

    console.log("param", param);
    console.log("response", response);

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      // setCountryList(listData);
      toastsuccessmsg(response.data.message);
      viewBookCartList(currency);
    } else {
      toasterrormsg(response.data.message);
      console.log(response.data);
      console.log(response.data.message);
    }
  };
  // View Cart API Call
  const viewBookCartList = async (currency) => {
    const param = {
      currency: currency,
    };

    var response = await postData("private/cart/view", param, apiHeader(false));

    console.log("response", response);

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.productDetail;
      const listData = data.map((data) => {
        return {
          bookId: data.book._id,
        };
      });
      setBookCartList(listData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  const isAddedToCartProducts = (bookId) =>
    bookCartList.some((item) => item.bookId === bookId);

  useEffect(() => {
    const bookFilterData = JSON.parse(decrypt(getCookie("bookFilter")) || "{}");
    console.log("bookFilterData", bookFilterData);

    if (bookFilterData) {
      setBookCountry(bookFilterData.bookCountry || "");
      setBookSubject(bookFilterData.bookSubject || "");
      setBookFormat(bookFilterData.bookFormat || "");
      setBookAvalability(bookFilterData.bookAvalability || "");
      setBookPublicationYear(bookFilterData.bookPublicationYear || "");
      setBookLanguage(bookFilterData.bookLanguage || "");

      viewBookList(
        countryService,
        selectedCountry,
        bookFilterData.bookCountry,
        bookFilterData.bookSubject,
        bookFilterData.bookFormat,
        bookFilterData.bookPublicationYear,
        bookFilterData.bookLanguage
      );
    } else {
      viewBookList(countryService, selectedCountry);
    }
  }, [countryService, selectedCountry]);

  useEffect(() => {
    viewCurrencyList();
    viewCountryList();
    viewSubjectList();
    viewFormatList();
    viewYearList();
    viewLanguageList();
  }, []);

  useEffect(() => {
    viewBookCartList(selectedCountry);
  }, [selectedCountry]);

  useEffect(() => {
    setCookie("b-plan-currency", "INR", {});
  }, []);

  useEffect(() => {
    const bookFilterData = JSON.parse(decrypt(getCookie("bookFilter")) || "{}");
    console.log("bookFilterData", bookFilterData);

    if (bookFilterData) {
      setBookCountry(bookFilterData.bookCountry || "");
      setBookSubject(bookFilterData.bookSubject || "");
      setBookFormat(bookFilterData.bookFormat || "");
      setBookAvalability(bookFilterData.bookAvalability || "");
      setBookPublicationYear(bookFilterData.bookPublicationYear || "");
      setBookLanguage(bookFilterData.bookLanguage || "");
    }
  }, []);

  // Apply Filter Function
  const applyFilter = (
    bookCountry,
    bookSubject,
    bookFormat,
    // bookAvalability,
    bookPublicationYear,
    bookLanguage
  ) => {
    const booksData = {
      bookCountry,
      bookSubject,
      bookFormat,
      // bookAvalability,
      bookPublicationYear,
      bookLanguage,
    };
    setCookie("bookFilter", encrypt(JSON.stringify(booksData)));

    // Get Data For Title Name
    const savedArticleFilterData = JSON.parse(
      decrypt(getCookie("bookFilter")) || "{}"
    );
    setBooksFilterData(savedArticleFilterData);

    viewBookList(
      countryService,
      selectedCountry,
      bookCountry,
      bookSubject,
      bookFormat,
      bookPublicationYear,
      bookLanguage
    );
  };

  // Clear Filter Function
  const clearFilter = () => {
    setBookCountry("");
    setBookSubject("");
    setBookFormat("");
    setBookAvalability("");
    setBookPublicationYear("");
    setBookLanguage("");
    deleteCookie("bookFilter");
    setBooksFilterData({});
    viewBookList(countryService, selectedCountry);
  };

  return (
    <>
      <ToastContainer />
      <div className="w-full p-[5%] section-books">
        <div className="xxl:container mx-auto">
          {/* <div className="flex relative z-[3] mb-10 lg:mb-5 justify-center items-center gap-5">
            <label className="currencylabel">Currency</label>
            <div className="w-[60%] md:w-[30%] currencyselect">
              <Select
                name="countryName"
                id="country"
                placeholder="Select Currency"
                className="w-full cs-main"
                isSearchable={true}
                options={currencyList}
                value={currencyList.find(
                  (item) => item.value === selectedCountry
                )}
                onChange={(e) => {
                  setSelectedCountry(e.value);
                  setCurrencySymbol(e.currency);
                  setCookie("b-plan-currency", e.currency, {});
                }}
                styles={selectStyle}
              />
            </div>
          </div> */}
          <div className="w-full grid lg:grid-cols-4 lg:justify-end">
            {/* <div className="w-full flex relative z-[3] mb-10 lg:mb-5 justify-center items-center gap-5">
              <label className="currencylabel">Currency</label>
              <div className="w-[60%] md:w-[30%] currencyselect">
                <Select
                  name="countryName"
                  id="country"
                  placeholder="Select Currency"
                  className="w-full cs-main"
                  isSearchable={true}
                  options={currencyList}
                  value={currencyList.find(
                    (item) => item.value === selectedCountry
                  )}
                  onChange={(e) => {
                    setSelectedCountry(e.value);
                    setCurrencySymbol(e.currency);
                    setCookie("b-plan-currency", e.currency, {});
                  }}
                  styles={selectStyle}
                />
              </div>
            </div> */}
            <div className="w-full lg:col-start-2 lg:col-end-4 flex relative z-[3] mb-10 lg:mb-5 justify-center items-center gap-5">
              <label className="currencylabel">Currency</label>
              <div className="w-[60%] currencyselect">
                <Select
                  name="countryName"
                  id="country"
                  placeholder="Select Currency"
                  className="w-full cs-main"
                  isSearchable={true}
                  options={currencyList}
                  value={currencyList.find(
                    (item) => item.value == selectedCountry
                  )}
                  onChange={(e) => {
                    setSelectedCountry(e.value);
                    setCurrencySymbol(e.currency);
                    setCookie("b-plan-currency", e.currency, {});
                  }}
                  styles={selectStyle}
                />
              </div>
            </div>
            <Link
              to="/viewcart"
              className="lg:block hidden col-start-4 w-max ml-auto mb-10 link-viewcart"
            >
              Shopping cart
            </Link>
          </div>
          <div className="w-full mb-5 md:mb-10">
            <div className="w-full grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-[2rem] gap-y-[1rem] mb-[2rem]">
              <div className="w-full">
                <Select
                  name="country"
                  id="country"
                  placeholder="Country"
                  className="w-full form-select form-input form-input2"
                  isSearchable={true}
                  options={countryList}
                  value={
                    countryList.find((item) => item.value == bookCountry) || ""
                  }
                  onChange={(e) => setBookCountry(e.value)}
                  styles={selectFormStyle2}
                />
              </div>
              <div className="w-full">
                <Select
                  name="subject"
                  id="subject"
                  placeholder="Subject"
                  className="w-full form-select form-input form-input2"
                  isSearchable={true}
                  options={subjectList}
                  value={
                    subjectList.find((item) => item.value == bookSubject) || ""
                  }
                  onChange={(e) => setBookSubject(e.value)}
                  styles={selectFormStyle2}
                />
              </div>
              <div className="w-full">
                <Select
                  name="format"
                  id="format"
                  placeholder="Format"
                  className="w-full form-select form-input form-input2"
                  isSearchable={true}
                  options={formatList}
                  value={
                    formatList.find((item) => item.value == bookFormat) || ""
                  }
                  onChange={(e) => setBookFormat(e.value)}
                  styles={selectFormStyle2}
                />
              </div>
              {/* <div className="w-full">
                <Select
                  name="avalability"
                  id="avalability"
                  placeholder="Availability"
                  className="w-full form-select form-input form-input2"
                  isSearchable={true}
                  // options={authorList}
                  // value={
                  //   authorList.find((item) => item.value == articleAuthor) || ""
                  // }
                  // onChange={(e) => setArticleAuthor(e.value)}
                  styles={selectFormStyle2}
                />
              </div> */}
              <div className="w-full">
                <Select
                  name="publication"
                  id="publication"
                  placeholder="Year"
                  className="w-full form-select form-input form-input2"
                  isSearchable={true}
                  options={yearList}
                  value={
                    yearList.find(
                      (item) => item.value == bookPublicationYear
                    ) || ""
                  }
                  onChange={(e) => setBookPublicationYear(e.value)}
                  styles={selectFormStyle2}
                />
              </div>{" "}
              <div className="w-full">
                <Select
                  name="language"
                  id="language"
                  placeholder="Language"
                  className="w-full form-select form-input form-input2"
                  isSearchable={true}
                  options={languageList}
                  value={
                    languageList.find((item) => item.value == bookLanguage) ||
                    ""
                  }
                  onChange={(e) => setBookLanguage(e.value)}
                  styles={selectFormStyle2}
                />
              </div>
              <div className="w-full xl:col-start-5">
                <button
                  onClick={() =>
                    applyFilter(
                      bookCountry,
                      bookSubject,
                      bookFormat,
                      bookPublicationYear,
                      bookLanguage
                    )
                  }
                  type="button"
                  className="w-full btn-filter"
                >
                  Apply filter
                </button>
              </div>
              <div className="w-full h-auto xl:col-start-4 xl:row-start-2">
                <div
                  type="button"
                  onClick={() => clearFilter()}
                  className="w-full h-full flex items-center justify-center lg:justify-start xl:justify-end"
                >
                  <button className="btn-filter-clear">Clear filter</button>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full flex flex-col items-center lg:items-start lg:flex-row gap-10 sec-books">
            {/* <div className="w-[90%] sm:w-[60%] lg:w-[25%] flex flex-col gap-5 sec-book-part1">
              {countryList.map((data, i) => (
                <div
                  className={
                    isOpen(i) ? "p-[2%] sbp1-box-active" : "p-[2%] sbp1-box"
                  }
                >
                  <button
                    onClick={() => toggleAccordion(i)}
                    className="flex w-full justify-between"
                  >
                    <span>{data.countryName}</span>
                    {isOpen(i) ? (
                      <IoIosArrowUp className="sbp1-up" />
                    ) : (
                      <IoIosArrowDown className="sbp1-down" />
                    )}
                  </button>
                  {isOpen(i) && (
                    <ul className="pl-[4rem] flex flex-col gap-5 px-4 pb-2 pt-4 book-country-ul">
                      {data.taxservice.map((data, i) => (
                        <li
                          onClick={() => setCountryService(data._id)}
                          className="text-start cursor-pointer book-country-ul-li"
                        >
                          {data.serviceName}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div> */}
            <div className="w-full flex lg:hidden justify-end">
              <Link to="/viewcart" className="link-viewcart">
                Shopping cart
              </Link>
            </div>
            {bookList.length > 0 && (
              <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-y-[5rem] gap-x-[3rem] sec-book-part2">
                {bookList.map((data, i) => (
                  <div className="w-full">
                    <div className="flex flex-col gap-5 items-center md:items-start w-full h-full sbp2-box">
                      <Link
                        to="/booksdetails"
                        onClick={() => setCookie("bookId", data.id, {})}
                        className="w-full"
                      >
                        <img
                          className="w-full aspect-square object-cover rounded-[2rem]"
                          src={data.image}
                          alt="Book Image"
                        />
                      </Link>
                      <Link
                        to="/booksdetails"
                        onClick={() => setCookie("bookId", data.id, {})}
                        className="sbp2-box-title"
                      >
                        {data.title}
                      </Link>
                      <h2 className="sbp2-box-price">
                        {data.currency} {formatPrice(data.price, data.currency)}
                      </h2>
                      <div className="flex items-center gap-10 csb1">
                        <CiCircleMinus
                          onClick={() => decrementQuantity(data.id)}
                          className="cursor-pointer csb1-icon"
                        />
                        <h3
                          style={{ userSelect: "none" }}
                          className="quantity csb1-no"
                        >
                          {getQuantity(data.id)}
                        </h3>
                        <CiCirclePlus
                          onClick={() => incrementQuantity(data.id)}
                          className="cursor-pointer csb1-icon"
                        />
                      </div>
                      <div className="w-full mt-auto flex gap-10 sbp2-box-btns">
                        <button
                          onClick={() => {
                            if(!auth){
                              toasterrormsg("Please login first");
                              return false;
                            }

                            if (isAddedToCartProducts(data.id)) {
                              toasterrormsg("Book Already Added In Cart!");
                            } else {
                              addBookInCart(
                                data.id,
                                getQuantity(data.id),
                                data.currency
                              );
                            }
                          }}
                          className="w-[50%] p-[4%] sbp2-box-btn1"
                        >
                          {isAddedToCartProducts(data.id)
                            ? "Already added"
                            : "Add to cart"}
                        </button>
                        <Link
                          to="/books/billing"
                          onClick={() => {
                            if(!auth){
                              toasterrormsg("Please login first");
                              return false;
                            }
                            setCookie("b-billingId", data.id, {});
                            setCookie("b-qty", getQuantity(data.id), {});
                          }}
                          className="w-[50%] p-[4%] sbp2-box-btn2"
                        >
                          <button className="w-full">Buy</button>
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
            {bookList.length == 0 && (
              <h1 className="w-full lg:w-[75%] text-center no-found">
                No book found
              </h1>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Books;
